import Echo, { type Broadcaster } from 'laravel-echo'

import { useCustomerStore } from '@entities/customer'

import { useListenEventAssessment } from './listen-event-assessment.hook'
import { useListenEventBooking } from './listen-event-booking.hook'
import { useListenEventCustomer } from './listen-event-customer.hook'
import { useListenEventRetryPayment } from './listen-event-subscription-retry.hook'
import { useStopListener } from './stop-listener.hook'
import { useListenEventProgressReport } from './listen-event-progress-report.hook'
import { useListenEventDiscipline } from './listen-event-discipline.hook'

export const useListenCustomerChannel = ($echo: Echo<keyof Broadcaster>): void => {
  const customerStore = useCustomerStore()

  if (customerStore.customer) {
    const name = `cs.customer.${customerStore.customer.id}`
    const channel = $echo.private(name)

    useListenEventCustomer(channel)
    useListenEventDiscipline(channel)
    useListenEventBooking(channel)
    useListenEventAssessment(channel)
    useListenEventRetryPayment(channel)
    useListenEventProgressReport(channel)

    useStopListener($echo, name, channel)
  }
}
